import React from 'react';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

const BillingTab = ({ orderData, setOrderData, transportOptions = [] }) => {
  return (
    <div className="space-y-3 pt-3">
      <div className="grid grid-cols-3 gap-3">
        <div>
          <Label className="text-xs">Dispatch Date</Label>
          <Input
            type="date"
            className="mt-1 h-9 text-xs bg-white"
            min={new Date().toISOString().split('T')[0]}
            value={orderData.dispatch_date}
            onChange={(e) => setOrderData({ ...orderData, dispatch_date: e.target.value })}
            data-testid="billing-dispatch-date"
          />
        </div>
        <div>
          <Label className="text-xs">Transporter</Label>
          <select
            data-testid="billing-transporter"
            value={orderData.transporter || ''}
            onChange={(e) => setOrderData({ ...orderData, transporter: e.target.value })}
            className="mt-1 h-9 text-xs w-full rounded-md border border-slate-200 bg-white px-2"
          >
            <option value="">-- Select Transporter --</option>
            {transportOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {transportOptions.length === 0 && (
            <p className="mt-1 text-[10px] text-slate-500">No transporters set for this customer. Add them in Masters → Transport.</p>
          )}
        </div>
        <div>
          <Label className="text-xs">Notes</Label>
          <Input
            className="mt-1 h-9 text-xs bg-white"
            value={orderData.notes}
            onChange={(e) => setOrderData({ ...orderData, notes: e.target.value })}
            placeholder="Any additional notes..."
            data-testid="billing-notes"
          />
        </div>
      </div>
    </div>
  );
};

export default BillingTab;
